import { action } from "typesafe-actions";
import { LoginActionType } from "./types";

export function loginStateChanged(isSubmitting: boolean) {
    return action(LoginActionType.LOGIN_STATE_CHANGED, { isSubmitting })
}
